import { Box, Flex, Grid, Overlay, Paper, Skeleton } from '@mantine/core';

import { StatisticsHeader } from '../../components/statistics-header/statistics-header';

import classes from './page.module.css';

export function PendingPage() {
  return (
    <>
      <Box mb="x2s" pos="relative">
        <StatisticsHeader />
        <Overlay opacity={0} />
      </Box>
      <Box my="x2s">
        <Skeleton h={370} />
      </Box>
      <Box mt="x2s">
        <Skeleton h={400} />
      </Box>
    </>
  );
}

export default PendingPage;
